export const generateParentServices = (request, map) => {
  const id = request.parentServiceId ?? 0;

  const entity = map.get(id) || {
    name: request.parentService ?? 'Не указано',
    value: 0,
    id,
  };

  entity.value += 1;
  map.set(id, entity);
};
